module.exports = __webpack_public_path__ + "static/10-0ce28dd3fbf3bbbb85ed1db6d37d9948.jpg";